import { useId, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/client/components/ui/card";
import { Button } from "@/client/components/ui/button";
import { Checkbox } from "@/client/components/ui/checkbox";
import { useAuth } from "@/client/lib/auth";
import { api } from "@/client/lib/api";

export function OnboardingPage() {
  const { user, refresh } = useAuth();
  const navigate = useNavigate();
  const privacyId = useId();
  const [privacyAck, setPrivacyAck] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!user) return null;

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!privacyAck) return;
    setSubmitting(true);
    setError(null);

    try {
      const res = await api.api.auth.onboard.$post({
        json: { privacyNoticeAcknowledged: true },
      });

      if (res.ok) {
        await refresh();
        navigate("/", { replace: true });
      } else {
        setError("Er ging iets mis. Probeer het opnieuw.");
      }
    } catch {
      setError("Kan geen verbinding maken met de server.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Card className="w-full max-w-md" render={<form onSubmit={handleSubmit} />}>
        <CardHeader>
          <CardTitle>Welkom bij Mijn KUVO Woerden</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm leading-6 text-muted-foreground">
            Fijn dat uw school meedoet aan het cultuuronderwijs in de regio Woerden. In een paar
            stappen geeft u door wat KUVO nodig heeft; uw antwoorden worden automatisch
            opgeslagen, dus u kunt altijd later verdergaan.
          </p>

          <label htmlFor={privacyId} className="flex items-start gap-3">
            <Checkbox id={privacyId} checked={privacyAck} onCheckedChange={(v) => setPrivacyAck(v === true)} className="mt-0.5 shrink-0" />
            <span className="text-sm leading-5">
              Ik heb de{" "}
              <Link to="/privacyverklaring" target="_blank" rel="noopener noreferrer" className="cursor-pointer font-medium text-primary hover:underline">
                privacyverklaring
              </Link>{" "}
              gelezen en daarvan kennisgenomen.
            </span>
          </label>

          {error && (
            <p className="text-sm text-destructive">{error}</p>
          )}
        </CardContent>
        <CardFooter>
          <Button type="submit" className="w-full" disabled={submitting || !privacyAck}>
            {submitting ? "Bezig..." : "Aan de slag"}
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
